export default "<ion-app>\n  <app-sidemenu></app-sidemenu>\n</ion-app>\n";